import SearchableDropdown, {
  CourseCategory as _CourseCategory,
  Course as _Course,
} from "./SearchableDropdown";
export type CourseCategory = _CourseCategory;
export type Course = _Course;
export default SearchableDropdown;
